// --- CONFIGURATION & MOCK DATA ---

export const QUERY_TYPES = {
  LEAD: {
    label: "Lead",
    color: "bg-purple-100 text-purple-700",
    icon: "monetization_on",
  },
  QUERY: {
    label: "Support",
    color: "bg-blue-100 text-blue-700",
    icon: "help",
  },
  CONVERSATION: {
    label: "Chat",
    color: "bg-green-100 text-green-700",
    icon: "forum",
  },
  FEEDBACK: {
    label: "Feedback",
    color: "bg-orange-100 text-orange-700",
    icon: "reviews",
  },
  CUSTOM: {
    label: "Other",
    color: "bg-gray-100 text-gray-700",
    icon: "widgets",
  },
};

export const STATUS_CONFIG = {
  NEW: { label: "New", color: "bg-blue-500 text-white" },
  CONTACTED: { label: "Contacted", color: "bg-yellow-500 text-white" },
  CONVERTED: { label: "Converted", color: "bg-green-600 text-white" },
  RESOLVED: { label: "Resolved", color: "bg-gray-500 text-white" },
  REVIEWED: { label: "Reviewed", color: "bg-indigo-500 text-white" },
  ARCHIVED: { label: "Archived", color: "bg-gray-300 text-gray-600" },
};

// Context-Aware Actions Definition
export const ACTIONS_CONFIG = {
  LEAD: [
    { action: "assign", label: "Assign", icon: "person_add" },
    { action: "contact", label: "Mark Contacted", icon: "call" },
    {
      action: "convert",
      label: "Convert",
      icon: "check_circle",
      variant: "primary",
    },
  ],
  QUERY: [
    { action: "reply", label: "Reply via Email", icon: "reply" },
    {
      action: "resolve",
      label: "Resolve",
      icon: "done_all",
      variant: "primary",
    },
  ],
  CONVERSATION: [
    { action: "chat", label: "Open Chat", icon: "chat" },
    { action: "archive", label: "Archive", icon: "archive" },
  ],
  FEEDBACK: [{ action: "review", label: "Mark Reviewed", icon: "visibility" }],
};

export const MOCK_QUERIES = [
  {
    id: "Q-101",
    formId: "F-001",
    formTitle: "Enterprise Sales Inquiry",
    formType: "LEAD",
    sender: "Rahul Biswas",
    email: "rahul@enterprise.com",
    submittedAt: "2025-12-20T10:30:00Z",
    status: "NEW",
    isUnread: true,
    data: {
      companySize: "500+",
      budget: "$50k - $100k",
      requirements: "Need API access and SSO.",
    },
  },
  {
    id: "Q-102",
    formId: "F-002",
    formTitle: "Product Support",
    formType: "QUERY",
    sender: "Sarah Jenkins",
    email: "sarah.j@gmail.com",
    submittedAt: "2025-12-19T14:15:00Z",
    status: "CONTACTED",
    isUnread: false,
    data: {
      issueType: "Login Issue",
      description: "Cannot reset password via magic link.",
      browser: "Safari",
    },
  },
  {
    id: "Q-103",
    formId: "F-003",
    formTitle: "Website Feedback Widget",
    formType: "FEEDBACK",
    sender: "Anonymous",
    email: "n/a",
    submittedAt: "2025-12-18T09:00:00Z",
    status: "NEW",
    isUnread: true,
    data: {
      rating: "4/5",
      comment: "Great UI, but dark mode is a bit too contrasty.",
    },
  },
  {
    id: "Q-104",
    formId: "F-004",
    formTitle: "Live Chat - Pricing",
    formType: "CONVERSATION",
    sender: "Mike Ross",
    email: "mike@pearson.com",
    submittedAt: "2025-12-20T11:00:00Z",
    status: "NEW",
    isUnread: true,
    messages: [
      {
        sender: "user",
        text: "Do you offer startup discounts?",
        time: "11:00 AM",
      },
    ],
  },
];
